<template>
  <div
    class="testContainer"
    :class="{isnotShowTit:type!==0?true:false}"
  >
    <div
      class="testCon"
      v-if="!isHasdata"
    >
      <div class="timer clearfix">
        <div
          class="fl"
          style="width:100%;color:#666;font-size:0.24rem;"
        >倒计时：<span>{{testTimer}}</span></div>
      </div>
      <div class="questionCon">
        <div class="qName">{{questionitem.number}}.
          <span class="qType">{{questionitem.type}}</span> {{questionitem.title}}
        </div>
        <ul>
          <li
            class="mnt-ans"
            v-for="(item,index) in answeritems"
            :key="index"
            v-on:click="selectanswer(index)"
            v-bind:class="{'active':item.isChecked == true,'dAns':item.rightanswer===true,'cAns':!(item.rightanswer)&&(item.rightanswer!=null)}"
          >
            <i>{{(item.index+1) | testItemFormate}}</i>{{item.selectitem}}
          </li>
        </ul>
        <mt-button
          type="default"
          class="sureBtn"
          @click="submitexambynumber"
          v-if="questionitem.type === ' 多选题 ' "
        >确定</mt-button>
      </div>
      <div
        class="questionCon ansBox"
        v-show="showAns"
      >
        <ul class="clearfix">
          <li class="fl">答案：<span class="rightAns">{{rightAns}}</span></li>
          <li class="fl">您选择：<span style="color:#999">{{myAns==0?"-":myAns}}</span>
          </li>
        </ul>
      </div>
      <p class="pages">{{questionitem.number}}/{{questioncount}}</p>
    </div>
    <div
      class="maskTest"
      v-show='isShowMask'
    ></div>
    <div
      class="testToast"
      v-show='isShowRes'
    >
      随堂测试结果
      <ul class="testResult">
        <li>
          <p class="allTi">{{questioncount}}</p>
          <p>题目总数</p>
        </li>
        <li>
          <p class="dTi">{{correctcount/5}}</p>
          <p>正确数</p>
        </li>
        <li>
          <p class="cTi">{{questioncount-correctcount/5}}</p>
          <p>错误数</p>
        </li>
      </ul>
      <div
        class="backH"
        @click="toBackH()"
      >确定</div>
    </div>
    <div
      v-if="isHasdata"
      class="noData"
    >
      <img
        src="../assets/imgs/noDataIcon.png"
        alt=""
      >
      <p>考题加载失败，请联系系统管理员</p>
    </div>
  </div>
</template>

<script>
import { getTestConfigs, getTrainTest } from '../../src/api/Api'
import { Toast, MessageBox } from 'mint-ui'
import { Dialog } from 'vant'
var video1
let clock
export default {
  data () {
    return {
      showAns: false,
      type: Number(this.$route.query.type), // app上不显示标题
      vId: this.$route.query.vId, // 视频id
      year: this.$route.query.year,
      folderId: this.$route.query.folderId,
      myPageTit: '考试',
      isHasdata: false,
      popupVisible: false,
      testTimer: 30, // 出题时间
      passScores: 0, // 考试合格成绩
      endTime: 5,
      rightAns: '',
      myAns: 0,
      QuestionList: [], // 所有试题
      ansItems: [], // 试题
      questioncount: '', // 总共多少道题
      currentNum: 1, // 当前题号
      nowquestionindex: 0, // 试题索引
      answeritems: [], // 试题答案选项
      items: [], // 答案区展示列表
      changebackcolor: '',
      choosedId: null, // 选中答案id
      correctcount: 0, // 对了几题
      score: 0, // 分数
      doneQ: 0,
      isPass: 0, // 是否开始通过
      ST: '', // 考试开始时间
      ET: '', // 考试结束时间
      isShowMask: false, // 考试结果-遮罩
      isShowRes: false, // 考试结果
      mulitem: '', // 多选
      paperData: {
        name: '', // 考试名称
        time: '', // 考试时间
        totalPoints: '', // 考试总分
        mcFraction: '', // 单选题分数(单个题)
        mcQFraction: '', // 多选题分数(单个题)
        judgmentFraction: '' // 判断题分数(单个题)
      },
      questionitem: {
        number: '', // 题号
        title: '', // 题目
        type: '', // 试题类型
        answerlist: '' // 试题选项
      }
    }
  },
  filters: {
    testItemFormate (val) {
      switch (val) {
        case 1:
          return 'A'
          break
        case 2:
          return 'B'
          break
        case 3:
          return 'C'
          break
        case 4:
          return 'D'
          break
        case 5:
          return 'E'
          break
        case 6:
          return 'F'
          break
      }
    }
  },
  created () {
    console.log('传入的参数：' + this.type + '||' + this.vId)
  },
  mounted () {
    // 确保dom元素加载后再执行方法
    // let con=document.getElementsByClassName("questionCon")[0]
    // console.log(window.innerHeight+'~~~!~!~!~!~!')
    // con.style.height= (window.innerHeight -229) *0.01+'rem'
    this.ST = this.dateFormat()
    console.log('开始时间戳' + this.ST)
    // this.GetTestConfigs()
    this.getQuestions(0)
  },
  methods: {
    fn: function (i) {
      this.changebackcolor = i
      this.nowquestionindex = i
      this.getquestionItem(i)
      this.getexamchange()
      this.popupVisible = !this.popupVisible
    },
    fomart (time) {
      var h, m, s
      // h = Math.floor(time / 3600)
      // m = Math.floor(time / 60 % 60)
      s = Math.floor(time % 60)
      // h < 10 ? h = '0' + h : h = h
      // m < 10 ? m = '0' + m : m = m
      s < 10 ? (s = '0' + s) : (s = s)
      return s
    },
    GetPreQuestionItem () {
      // 上一题
      this.nowquestionindex--
      this.changebackcolor = this.nowquestionindex
      this.getquestionItem(this.nowquestionindex)
      this.getexamchange()
    },
    GetNextQuestionItem () {
      window.clearInterval(clock)
      this.showAns = false
      if (this.nowquestionindex === this.questioncount) {
        return false
      } else {
        // this.GetTestConfigs()
        // 下一题
        this.rest()
        this.nowquestionindex++
        this.changebackcolor = this.nowquestionindex
        this.getquestionItem(this.nowquestionindex)
        this.getexamchange()
      }
    },
    getexamchange () {
      // 换题
      var _this = this
      var item = this.items[this.nowquestionindex]
      if (item.isright !== null) {
        _this.answeritems.forEach(x => {
          x.hasexamed = true
        })
      }
    },
    getQuestions (nowquestionindex) {
      this.rest()
      // 获取试题及加载答案区
      getTrainTest({
        id: this.vId
      }).then(res => {
        if (res.data.returnCode === 1) {
          this.isHasdata = false
          this.QuestionList = res.data.returnDate
          this.questioncount = this.QuestionList.length // 试题数量
          if (this.questioncount < 1) {
            Dialog.alert({
              title: '提示',
              message: '该视频无随堂练习！'
            }).then(() => {
              this.toBackH()
            })
          }
          // 加载答案选项
          var answerarray = []
          var qcount = this.questioncount + 1
          for (var j = 1; j < qcount; j++) {
            var arrayjosn = {
              isright: null,
              title: '',
              Id: j
            }
            answerarray.push(arrayjosn)
          }
          this.items = answerarray
          this.getquestionItem(nowquestionindex)
        } else {
          this.isHasdata = true
        }
      })
    },
    getquestionItem (questionindex) {
      // 根据索引获取试题
      var _this = this
      var QuestionItem = _this.QuestionList[questionindex]
      _this.questionitem.type = QuestionItem['type'] // 题型
      _this.questionitem.number = questionindex + 1 // 题号
      _this.questionitem.title = QuestionItem['questionsName'] // 试题
      _this.questionitem.answerlist = QuestionItem['questionitem'].split(',') // 答案选项列表
      if (QuestionItem['type'] === 1) {
        _this.questionitem.type = ' 单选题 '
      } else if (QuestionItem['type'] === 2) {
        _this.questionitem.type = ' 多选题 '
      } else if (QuestionItem['type'] === 3) {
        _this.questionitem.type = ' 判断题 '
      }
      // 加载试题选项按钮
      var objectanswer = []
      var ArrayAnswer = _this.questionitem.answerlist // 选项
      for (var i = 0; i < ArrayAnswer.length; i++) {
        var ifin = -1
        if (this.items.length > 0) {
          // 做过了
          ifin = this.items[this.nowquestionindex].title.indexOf(ArrayAnswer[i])
        }
        var answeritem = {
          hasexamed: this.items.length > 0 && ifin != -1,
          selectitem: ArrayAnswer[i],
          isChecked: this.items.length > 0 && ifin != -1,
          index: i,
          rightanswer: null
        }
        objectanswer.push(answeritem)
      }
      _this.answeritems = objectanswer
    },
    selectanswer: function (answeritem) {
      window.clearInterval(clock)
      var hasSelect = document.getElementsByClassName('dAns').length
      if (hasSelect || this.showAns) {
        // 做过了 就不能再选了
        return false
      }
      // 选择答案
      var _this = this
      var examtype = ''
      var item = _this.answeritems[answeritem].selectitem
      if (_this.questionitem.type === ' 多选题 ') {
        if (_this.answeritems[answeritem].isChecked === true) {
          _this.answeritems[answeritem].isChecked = false
        } else {
          _this.answeritems[answeritem].isChecked = true
        }
      } else {
        _this.myAns = _this.getitembyselect(answeritem + 1)
        // var ss = this.QuestionList[this.nowquestionindex]['answer']
        // console.log(this.answeritems[answeritem])
        // 正确答案
        if (
          _this.QuestionList[_this.nowquestionindex]['answer'] ===
          _this.answeritems[answeritem].selectitem
        ) {
          console.log(
            '你选择的是：' +
              this.answeritems[answeritem].selectitem +
              '正确答案是' +
              this.QuestionList[this.nowquestionindex]['answer']
          )
          // console.log(this.answeritems)
          _this.answeritems.forEach(v => {
            if (
              v.selectitem ===
              _this.QuestionList[_this.nowquestionindex]['answer']
            ) {
              _this.rightAns = _this.getitembyselect(v.index + 1)
              _this.answeritems[answeritem].rightanswer = true
              console.log('单选答案---' + _this.rightAns)
            }
          })
        } else {
          _this.answeritems[answeritem].rightanswer = false
          _this.answeritems.forEach(v => {
            if (
              v.selectitem ===
              _this.QuestionList[_this.nowquestionindex]['answer']
            ) {
              _this.rightAns = _this.getitembyselect(v.index + 1)
              v.rightanswer = true
              console.log('单选答案++++' + _this.rightAns)
            }
          })
        }
        // console.log(this.answeritems + '!!!@!@!@!@')
        if (_this.answeritems[answeritem].isChecked === true) {
          _this.answeritems.forEach(k => {
            if (k !== _this.answeritems[answeritem]) {
              k.isChecked = false
            }
          })
        } else {
          this.answeritems[answeritem].isChecked = true
          this.answeritems.forEach(k => {
            if (k !== this.answeritems[answeritem]) {
              k.isChecked = false
            }
          })
        }
        this.showAns = true
      }
      if (_this.questionitem.type === ' 多选题 ') {
        examtype = '2'
        // 如果存在已经选择的则去除
        if (_this.mulitem.indexOf(item) !== -1 && _this.mulitem.length > 0) {
          _this.mulitem = _this.mulitem.replace(item, '')
          _this.items[_this.nowquestionindex].title = _this.mulitem.trim()
        } else {
          _this.mulitem += item + ','
          _this.items[_this.nowquestionindex].title = _this.mulitem
        }
      }
      if (examtype !== '2') {
        _this.mulitem = ''
        _this.items[_this.nowquestionindex].title = item
        _this.submitexambynumber()
      }
    },
    getitembyselect (val) {
      switch (val) {
        case 1:
          return 'A'
          break
        case 2:
          return 'B'
          break
        case 3:
          return 'C'
          break
        case 4:
          return 'D'
          break
        case 5:
          return 'E'
          break
        case 6:
          return 'F'
          break
      }
    },
    submitexambynumber () {
      var _this = this
      var mutiselectitem = ''
      var rightanswer = ''
      // console.log(_this.QuestionList[_this.nowquestionindex])
      // console.log(this.answeritems)
      if (_this.questionitem.type === ' 多选题 ') {
        var sitem = ''
        _this.answeritems.forEach(x => {
          if (x.isChecked) {
            sitem += x.selectitem + ','
            mutiselectitem += this.getitembyselect(x.index + 1) + ','
          }
          var rights = _this.QuestionList[_this.nowquestionindex][
            'answer'
          ].split(',')
          // console.log(rights)
          rights.forEach(r => {
            if (r === x.selectitem) {
              rightanswer += _this.getitembyselect(x.index + 1)
              x.rightanswer = true
            } else {
              if (x.isChecked) {
                x.rightanswer = false
              }
            }
          })
          _this.rightAns = rightanswer
          // console.log('正确答案' + rightanswer)
        })
        _this.items[_this.nowquestionindex].title = sitem.substring(
          0,
          sitem.lastIndexOf(',')
        )
        _this.myAns = mutiselectitem.substring(
          0,
          mutiselectitem.lastIndexOf(',')
        )
      }
      var answerarray = _this.items[_this.nowquestionindex].title
      var tempArray = _this.QuestionList
      var questionitem = tempArray[_this.nowquestionindex]
      if (questionitem['answer'] === answerarray) {
        _this.items[_this.nowquestionindex].isright = true
        if (_this.questionitem.type === ' 多选题 ') {
          _this.rightAns = mutiselectitem.substring(
            0,
            mutiselectitem.lastIndexOf(',')
          )
        }
      } else {
        _this.items[_this.nowquestionindex].isright = false
      }
      this.CoungtScore()
      this.showAns = true
      if (_this.nowquestionindex < _this.items.length - 1) {
        // 不是最后一题 就自动跳到下一题
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
        setTimeout(() => {
          _this.GetNextQuestionItem()
        }, 4000)
      }
    },
    CoungtScore () {
      this.correctcount = 0
      this.doneQ = 0
      this.items.forEach(k => {
        if (k.isright === true) {
          this.correctcount += 5 // 每道题5分
        }
        if (k.title !== '') {
          this.doneQ++
        }
      })
      if (this.nowquestionindex + 1 === this.questioncount) {
        // 题做完了
        setTimeout(() => {
          this.isShowMask = true
          this.isShowRes = true
        }, 4000)
      }
      console.info(
        this.items.length +
          '当前得分：' +
          this.correctcount +
          '@@@index:' +
          this.nowquestionindex
      )
    },
    /**
     * 提交试卷
     */
    SubmitExam (isTimeout) {
      // 判断是否是超时导致
      if (isTimeout) {
        this.commitanswer()
      } else {
        MessageBox({
          title: '提示',
          message: '是否确认交卷?',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(action => {
          if (action === 'confirm') {
            // 确认的回调
            this.commitanswer()
          } else {
            return false
          }
        })
      }
    },
    commitanswer () {
      this.ET = this.dateFormat()
      console.log('结束时间戳' + this.ET)
      // 判断是否通过考试
      var _this = this
      if (_this.loginstate !== '1') {
        if (_this.correctcount >= _this.passScores) {
          // Toast('恭喜您考试成绩合格')
          _this.isPass = 1
        } else {
          // Toast('您本次考试成绩为:' + _this.correctcount + '分，未达到合格分数，未通过考试')
          _this.isPass = 0
        }
      }
    },
    toBackH () {
      switch (this.type) {
        case 0: // 微信
          this.$router.replace({
            path: '/vList',
            query: { year: this.year, folderId: this.folderId }
          })
          break
        case 1: // android
          register_js.register('')
          break
        case 2: // ios
          nativeMethod.back()
          break
      }
    },
    rest () {
      this.testTimer = 30
      clock = window.setInterval(() => {
        this.testTimer--
        if (this.testTimer < 1) {
          window.clearInterval(clock)
          this.showAns = true
          if (this.questionitem.type !== ' 多选题 ') {
            this.answeritems.forEach(p => {
              if (
                p.selectitem ===
                this.QuestionList[this.nowquestionindex]['answer']
              ) {
                p.rightanswer = true
                this.rightAns = this.getitembyselect(p.index + 1)
              }
            })
          } else {
            var mutiselectitem = ''
            var rightanswer = ''
            this.answeritems.forEach(x => {
              if (x.isChecked) {
                // sitem += x.selectitem + ','
                mutiselectitem += this.getitembyselect(x.index + 1) + ','
              }
              var rights = this.QuestionList[this.nowquestionindex][
                'answer'
              ].split(',')
              // console.log(rights)
              rights.forEach(r => {
                if (r === x.selectitem) {
                  rightanswer += this.getitembyselect(x.index + 1)
                  x.rightanswer = true
                }
              })
              this.rightAns = rightanswer
              // console.log('正确答案' + rightanswer)
            })
          }
          if (this.nowquestionindex + 1 == this.questioncount) {
            // 题做完了
            this.isShowMask = true
            this.isShowRes = true
            window.clearInterval(clock)
            return false
          }
          setTimeout(() => {
            // 答题时间到了
            this.GetNextQuestionItem()
            this.testTimer = 30
          }, 2000)
        }
      }, 1000)
    },
    dateFormat () {
      var date = new Date()
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      )
    }
  },
  computed: {
    // rest () {
    //   return this.fomart(this.endTime)
    // }
  },
  destroyed () {
    console.log('xioahui')
    // Toast('返回将视为自动交卷')
  }
}
</script>

<style scoped>
#app {
  padding-top: 0;
}
body {
  background: #f2f2f2;
}
.isnotShowTit {
  top: 0;
}
.isnotShowTit .mint-header {
  display: none;
}
/* .body-bg{
        height: auto;
      } */
.testContainer {
  padding: 0 0.15rem;
  width: 100%;
  box-sizing: border-box;
}
.timer > div {
  width: 20%;
  color: #92b8fe;
  height: 0.4rem;
}
.testNums {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: 0.4rem;
}
.testNums dd {
  flex: 0 0 20%;
  padding: 0.2rem;
  height: 0.56rem;
  box-sizing: border-box;
  text-align: center;
  margin: 0.1rem 0;
}
.testNums dd span {
  height: 0.56rem;
  line-height: 0.56rem;
  box-sizing: border-box;
  border: 1px solid #ccc;
  text-align: center;
  width: 100%;
  display: inline-block;
  border-radius: 0.28rem;
  color: #666;
}
.testNums dd span.done {
  background: #80c269;
  border-color: #80c269;
  color: #fff;
}
.testNums dd span.mnt-now {
  background: #addc9d;
  border-color: #addc9d;
  color: #fff;
}
.ansCon {
  height: 88%;
  overflow: auto;
}
.shouqi {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0.96rem;
  line-height: 0.96rem;
  background: #fff;
  border-top: 1px solid #dcdcdc;
  text-align: center;
  color: #999;
}
.testContainer .panle {
  width: 100%;
  background: #fff;
  top: 0.9rem;
  bottom: 0;
  padding-bottom: 0.96rem;
}
.panleTop {
  background: #92b8fe;
  height: 1.2rem;
  line-height: 1.2rem;
  text-align: center;
  color: #fff;
}
.panleTop .fl {
  width: 50%;
}
.testContainer .mint-cell::before {
  border: none;
}
.czBtn {
  margin: 0.9rem auto 0.2rem;
}
.czBtn .fl {
  width: 50%;
  text-align: center;
}
.czBtn img {
  width: 0.6rem;
  height: 0.6rem;
}
.testContainer .pages {
  color: #ccc;
  font-size: 0.24rem;
  text-align: center;
  margin-bottom: 0.3rem;
  margin-top: 0.8rem;
}
.mnt-ans {
  line-height: 0.4rem;
  margin: 0.4rem 0;
  color: #666;
}
.mnt-ans i {
  font-style: normal;
  width: 0.4rem;
  height: 0.4rem;
  text-align: center;
  line-height: 0.4rem;
  border-radius: 100%;
  border: 1px solid #999;
  background: #fff;
  color: #666;
  display: inline-block;
  margin-right: 0.2rem;
  font-size: 0.26rem;
}
.mnt-ans.active {
  color: #92b8fe;
}
.mnt-ans.active i {
  background: #92b8fe;
  border: 1px solid #92b8fe;
  color: #fff;
}
.testCon .mnt-ans.cAns {
  color: #ff2a00;
}
.testCon .mnt-ans.cAns i {
  border: 1px solid #ff2a00;
}
.testCon .mnt-ans.dAns {
  color: #6da0f3;
}
.testCon .mnt-ans.dAns i {
  border: 1px solid #6da0f3;
}
.maskTest {
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 2;
}
.testToast {
  width: 70%;
  height: 4rem;
  background: #fff;
  border-radius: 0.1rem;
  position: fixed;
  z-index: 333;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  padding: 0.75rem 0.4rem;
  color: #666;
  text-align: center;
}
.testToast img {
  width: 2.28rem;
  height: 2.02rem;
  display: block;
  margin: 0.35rem auto 0.54rem;
}
.backH {
  height: 0.56rem;
  line-height: 0.56rem;
  width: 2.02rem;
  text-align: center;
  color: #fff;
  background: linear-gradient(
    240deg,
    rgba(146, 184, 254, 1),
    rgba(121, 160, 231, 1)
  );
  border-radius: 0.28rem;
  margin: 0.8rem auto 0;
}
.timer {
  color: #666;
  font-size: 0.3rem;
  padding: 0 0.2rem;
  text-align: center;
  height: 1.28rem;
  line-height: 1.28rem;
}
.timer span {
  color: #333;
  font-size: 0.3rem;
}
.qType {
  border-radius: 0.1rem;
  background: #92b8fe;
  color: #fff;
  font-size: 0.2rem;
  padding: 0.05rem 0.1rem;
  line-height: 0.28rem;
  vertical-align: middle;
  margin-right: 0.2rem;
}
.questionCon {
  font-size: 0.3rem;
  line-height: 0.44rem;
  background: #fff;
  padding: 0.3rem;
}
.sureBtn {
  width: 2.28rem;
  height: 0.56rem;
  background: rgba(146, 184, 254, 1);
  border-radius: 0.1rem;
  margin: 0.8rem auto 0;
  color: #fff;
  font-size: 0.3rem;
  display: block;
}
.mint-msgbox-message {
  text-align: center;
}
.mnt-ans.dAns i {
  background: url(../assets/imgs/rAns.png) no-repeat center;
  background-size: cover;
  color: transparent;
}
.mnt-ans.cAns i {
  background: url(../assets/imgs/cAns.png) no-repeat center;
  background-size: cover;
  color: transparent;
}
.testResult {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 1rem;
}
.testResult p {
  color: #666;
  text-align: center;
}
.testResult .allTi {
  font-size: 0.6rem;
  color: #333;
}
.testResult .dTi {
  font-size: 0.6rem;
  color: #6da0f3;
}
.testResult .cTi {
  font-size: 0.6rem;
  color: #ff2a00;
}
</style>



// WEBPACK FOOTER //
// src/views/classTest.vue